module.exports = __webpack_public_path__ + "img/MAGAYA-LOGO.3485003c.png";